import { useSearchParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { Mail } from "../../classes/mail.tsx";
import LoadingBarApp from "../../widgets/loading";
import { LoadingPage, NavbarHeight } from "../../widgets/small-widgets";
import Navbar from "../../widgets/navbar";
import { useState } from "react";
import MailDetailsView from "../../widgets/mails/mail-details.jsx";
import { useTranslation } from "react-i18next";

export default function MailDetails({}) {
    const { t } = useTranslation();

    const [searchParams, setSearchParams] = useSearchParams();
    const mailId = searchParams.get('id');

    const [mail, setMail] = useState(null);

    async function getMail() {
        var q = doc(db, 'mail', mailId);
        const mailData = await getDoc(q);
        if (mailData.exists()) {
            const mail = Mail.fromJson(mailData.data(), mailId);
            console.log(mail);
            setMail(mail);
        } else {
            setMail(undefined);
        }
    }

    if (mail === null) {
        getMail();
    }

    return mail != null && mail != undefined
        ? <MailDetailsView mail={mail}/>
        : mail === null 
            ? <LoadingPage/>
            : <div className="expand-width" style={{alignItems: 'center'}}>
                <h1>{t('mails.noMail') + mailId}</h1>
            </div>
}